import type { App } from "vue"
import type { ModuleDefinition, ModuleOptions } from "@core/types/module"

const irveModule: ModuleDefinition = {
    name: "irve",

    install(_app: App, _options: ModuleOptions): void {
        // Initialisation du module
    },
}

export default irveModule
